<footer>
  <div class="bg-primary pt-6">
    <div class="container-xl text-white">
      <div class="row">
        <div class="col-md-4">
          <img alt="Labcorp | Payer" class="footer-logo mb-6" src="assets/public/images/logo-labcorp-white.png">
        </div>

        <div class="col-md-4 offset-md-4">
          <ul class="list-unstyled">
            <li><u><a href="#" class="text-white">Sign In</a></u></li>
            <li><u><a href="mailto:LabcorpPayerSupport@Labcorp.com" target="_top" class="text-white">Contact Support</a></u></li>
            <li><u><a href="https://www.labcorp.com" target="_blank" rel="noopener" class="text-white">Labcorp.com</a></u></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="bg-navy py-4 mt-4">
      <div class="container-xl text-white">
        <p class="small mb-0 text-center text-md-left">Labcorp | Payer™ {{appVersion}} &copy;{{ appYear }} Laboratory Corporation of America® Holdings. All Rights Reserved. Visit
          <a href="https://www.labcorp.com/" target="_blank" rel="noopener" lass="text-white">labcorp.com</a> | <a href="https://www.labcorp.com/hipaa-privacy" target="_blank" rel="noopener" class="text-white">Privacy Statement</a>
        </p>
      </div>
    </div>
  </div>
</footer>
